import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { Table, Divider, Popconfirm, Typography, Button, Modal, Spin, message } from "antd";
import { baseUrl, platformApi } from "../../../../api";
const { Text } = Typography;
import { ContextAPI } from "../../../../ContextAPI";
import PaymentModal from "../../../paymentModal";
import ViewPayments from "../../../paymentModal/ViewPayments";
import LedgerModal from "../../Ledger/LedgerModal";

function InvoiceTable(props) {
  const {
    history,
    gst,
    pagination,
    dataSource,
    spinner,
    setModifyAccess,
    modify,
    deleteData,
    setEditable,
    setEditableData,
    deleteAccess,
    printAccess,
    tab,
    refreshData
  } = props;

  const { loginCredintials } = useContext(ContextAPI);

  const hasCashCollectAccess = () => {
    if (loginCredintials?.roleAccess) {
      return loginCredintials.roleAccess.some(
        (acc) =>
          acc.master === "TRANSACTIONMASTER" &&
          (acc.subModule === "Cash Payment" ||
            acc.subModule == "POS Machine") &&
          acc.access.create === true
      );
    }
    return false;
  };

  const hasReceiptAccess = () => {
    if (loginCredintials?.roleAccess) {
      return loginCredintials.roleAccess.some(
        (acc) =>
          acc.subModule === "Receipt" &&
          acc.access.read === true
      );
    }
    return false;
  };

  const [paymentOpen, setPaymentOpen] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [receiptOpen, setReceiptOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerLedgerOpen, setCustomerLedgerOpen] = useState(false);
  const [binModalVisible, setBinModalVisible] = useState(false);
  const [binModalLoading, setBinModalLoading] = useState(false);
  const [binModalItems, setBinModalItems] = useState([]);

  const handleOpenBinModal = async (record) => {
    setBinModalVisible(true);
    setBinModalLoading(true);
    setBinModalItems([]);

    try {
      const res = await platformApi.get(`/api/saleSpareInvoice/${record.id}`);
      const invoiceData = res?.data?.response?.data || res?.data?.response || res?.data;
      const saleItemInvoice = invoiceData?.saleItemInvoice || record?.saleItemInvoice || [];
      const branchId = invoiceData?.branch?.id || record?.branch?.id || (Array.isArray(loginCredintials?.branch) ? loginCredintials.branch[0]?.id : loginCredintials?.branch?.id);

      // Filter only spare parts (exclude job codes)
      const spareItems = saleItemInvoice.filter(item => {
        if (item.jobCode) return false;
        if (item.partNumber && item.partNumber.jobCode) return false;
        if (!item.partNumber) return false;
        return true;
      });

      const formattedItems = await Promise.all(
        spareItems.map(async (item, idx) => {
          const partId = item.partNumber?.id;
          const partCode = item.partNumber?.partNumber || item.partNumber?.code || "";
          const partName = item.partNumber?.partName || item.partName || "";
          const partQty = item.quantity ?? item.qty ?? 0;

          let binLocation = "-";

          if (partId) {
            try {
              const invRes = await platformApi.post("/api/sparesInventory/getPart", {
                partNo: partId,
                branch: branchId,
                skipNull: false,
              });
              const invDataList = invRes?.data?.response?.data?.sparesInventory || invRes?.data?.data?.sparesInventory || [];
              if (invDataList && invDataList.length > 0) {
                const matchedInv = invDataList.find(si => si.branch === branchId) || invDataList[0];
                binLocation = matchedInv?.binNum || "-";
              }
            } catch (err) {
              console.error("Error fetching inventory for part:", partId, err);
            }
          }

          return {
            key: item.id || idx,
            partsDetails: `${partCode}${partCode && partName ? " - " : ""}${partName}`,
            qty: partQty,
            binLocation: binLocation,
          };
        })
      );

      setBinModalItems(formattedItems);
    } catch (err) {
      console.error("Error fetching invoice details for BIN Location:", err);
      message.error("Failed to load BIN Location details");
    } finally {
      setBinModalLoading(false);
    }
  };

  const column = [
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      width: 150,
      render: (record) => (
        <span>{moment(new Date(record)).format("DD/MM/YYYY")}</span>
      ),
    },
    {
      title: "Invoice No",
      dataIndex: "invoiceNumber",
      width: 150,
      key: "invoiceNumber",
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Party Name",
      dataIndex: "partyName",
      key: "partyName",
      width: 150,
      render: (party, data) => {
        const customerObj = party || data?.customer;
        return (
          <span
            className="linkylink"
            onClick={(e) => {
              e.stopPropagation();
              if (customerObj) {
                setSelectedCustomer(customerObj);
                setCustomerLedgerOpen(true);
              }
            }}
          >
            {customerObj?.name || "-"}
          </span>
        );
      },
    },
    {
      title: "Total Amount",
      dataIndex: "totalInvoice",
      key: "totalInvoice",
      width: 150,
      render: (record) => <span>{record}</span>,
    },
    {
      title: "Payment Status",
      key: "jobOrder",
      width: 150,
      render: (record) => (
        <span>{record && record.jobOrder ? record.jobOrder.jobStatus : record?.status ? record.status : "Pending"}</span>
      ),
    },
    {
      title: <span>Actions</span>,
      key: "actions",
      width: 320,
      render: (data) => (
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
          }}
        >
          <span
            className="linkylink"
            onClick={(event) => {
              event.stopPropagation();
              handleOpenBinModal(data);
            }}
          >
            BIN Location
          </span>
          {modify && data.status !== "PAID" && data.status !== "FEEDBACK_COMPLETED" ? (
            <span
              onClick={(event) => {
                event.stopPropagation();
                // setModifyAccess(true)
                history.push({
                  pathname: `/autoadmin/counter_sale/${data.id}`,
                  state: {
                    gst: gst,
                    editable: true,
                  },
                });
              }}
              className="linkylink"
            >
              Modify
            </span>
          ) : (
            <span></span>
          )}
          {deleteAccess ? (
            <Popconfirm
              title="Do you want to delete SSI?"
              okText="Yes"
              cancelText="No"
              onCancel={(event) => {
                event.stopPropagation();
              }}
              onConfirm={(event) => {
                event.stopPropagation();
                deleteData(data.id);
              }}
            >
              <span
                className="linkylink"
                onClick={(event) => event.stopPropagation()}
              >
                Delete
              </span>
            </Popconfirm>
          ) : (
            <span></span>
          )}
          {printAccess && tab !== "PENDING" ? (
            <a
              href={`${baseUrl}api/saleSpareInvoice/generatePDF/${data.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="linkylink"
            >
              Print
            </a>
          ) : (
            <span></span>
          )}
          {/* {hasCashCollectAccess() && tab == "PENDING" && (
              <>
                <Divider type="vertical" />
                  <Button
                    type="primary"
                    size="small"
                    onClick={(event) => {
                      event.stopPropagation();
                      setPaymentOpen(true);
                      setSelectedData(data);
                    }}
                  >
                    Collect Cash
                  </Button>
              </>
            )} */}

            {
            hasReceiptAccess() && tab !== "PENDING" && (
              <>
                {/* <Divider type="vertical" /> */}
                <span
                  className="linkylink"
                  onClick={(event) => {
                    event.stopPropagation();
                    setReceiptOpen(true);
                    setSelectedData(data);
                  }}
                >
                  Receipts
                </span>
              </>
            )
          }

          {hasCashCollectAccess() && tab === "PENDING" && data && (
            <>
              <Divider type="vertical" />
              {(() => {
                const payments = data.payment
                  ? Array.isArray(data.payment)
                    ? data.payment
                    : [data.payment]
                  : [];

                const totalCollected = payments.reduce(
                  (sum, p) =>
                    p.status === "SUCCESS"
                      ? sum + (Number(p.collectedAmount) || 0)
                      : sum,
                  0
                );

                const billAmount = Number(data.totalInvoice || 0);
                const remainingAmount = billAmount - totalCollected;
                const isFullyPaid = totalCollected >= billAmount;
                const isPartiallyPaid = totalCollected > 0 && !isFullyPaid;

                return (
                  <Button
                    type="primary"
                    size="small"
                    onClick={(event) => {
                      event.stopPropagation();
                      setPaymentOpen(true);
                      setSelectedData(data);
                    }}
                  >
                    {isPartiallyPaid
                      ? `Collect Remaining ₹${remainingAmount}`
                      : "Collect Cash"}
                  </Button>
                );
              })()}
            </>
          )}

          {!modify &&
          !deleteAccess &&
          !printAccess &&
          !hasCashCollectAccess() ? (
            <Text strong disabled>
              No Actions Given
            </Text>
          ) : (
            <span></span>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <Table
        rowKey={(record) => {
          record.id;
        }}
        pagination={pagination}
        columns={column}
        tableLayout="fixed"
        loading={spinner}
        dataSource={dataSource}
        onRow={(record) => ({
          onClick: () => {
            history.push({
              pathname: `/autoadmin/counter_sale/${record.id}`,
              state: {
                gst: gst,
              },
            });
          },
        })}
      />

      {paymentOpen && (
        <PaymentModal
          visible={paymentOpen}
          onClose={() => {
            setPaymentOpen(false);
            refreshData();
          }}
          data={selectedData}
          module={"COUNTER_SALES"}
          moduleId={selectedData.id}
          branchId={selectedData?.branch?.id}
        />
      )}

      {
        receiptOpen && (
          <ViewPayments
            open ={receiptOpen}
            close={() => {
              setReceiptOpen(false);
              refreshData();
            }}
            data={selectedData?.payment}
            module={"counter_sales"}
          />
        )
      }

      <Modal
        title="BIN Location"
        visible={binModalVisible}
        onCancel={() => setBinModalVisible(false)}
        footer={[
          <Button key="close" type="primary" onClick={() => setBinModalVisible(false)}>
            Close
          </Button>
        ]}
        width={750}
      >
        <Spin spinning={binModalLoading}>
          <Table
            dataSource={binModalItems}
            pagination={false}
            rowKey="key"
            columns={[
              {
                title: "S.No",
                key: "sno",
                width: 70,
                render: (text, record, index) => index + 1,
              },
              {
                title: "Parts Details",
                dataIndex: "partsDetails",
                key: "partsDetails",
                width: 320,
              },
              {
                title: "Qty",
                dataIndex: "qty",
                key: "qty",
                width: 140,
              },
              {
                title: "Bin Location",
                dataIndex: "binLocation",
                key: "binLocation",
                width: 140,
              },
            ]}
          />
        </Spin>
      </Modal>

      {customerLedgerOpen && selectedCustomer && (
        <LedgerModal
          visible={customerLedgerOpen}
          onCancel={() => {
            setCustomerLedgerOpen(false);
            setSelectedCustomer(null);
          }}
          data={selectedCustomer}
          type="CUSTOMERS"
          initialSubTab="COUNTER_SALES"
        />
      )}
    </>
  );
}

export default withRouter(InvoiceTable);
